import React, { createContext, useState, useContext, useEffect } from 'react';
// Import the translation objects
// ACTION: Verify these paths are correct relative to LanguageContext.js
import { esTranslations } from '../translations/es';
import { enTranslations } from '../translations/en';

// Combine into a single structure for easy lookup
const translations = {
  es: esTranslations,
  en: enTranslations,
};

// Create context
const LanguageContext = createContext();

// Create provider component
export const LanguageProvider = ({ children }) => {
  // Try to get initial language from localStorage or default to 'es'
  const [language, setLanguage] = useState(() => {
      const savedLang = localStorage.getItem('appLanguage');
      return savedLang && translations[savedLang] ? savedLang : 'es';
  });

  // Save language changes to localStorage
  useEffect(() => {
      localStorage.setItem('appLanguage', language);
  }, [language]);

  // Function to change language
  const changeLanguage = (lang) => {
    // Only allow valid languages defined in translations
    if (translations[lang]) {
      setLanguage(lang);
    } else {
        console.warn(`Attempted to change to unsupported language: ${lang}`);
    }
  };

  // Translation function - looks up key in the current language object
  const translate = (key) => {
    // Use optional chaining for safety
    return translations[language]?.[key] || key; // Fallback to the key itself
  };

  // Value provided by the context
  const value = {
    language,        // The current language code ('en', 'es')
    changeLanguage,  // Function to change the language
    translate,       // Function to get a translation string
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to easily consume the context in components
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    // This error is helpful during development
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};